<div class="modal-backdrop" *ngIf="isVisible" (click)="onBackdropClick($event)">
  <div class="modal-container">
    <div class="modal-header">
      <h3>{{ title }}</h3>
      <button class="close-button" (click)="closeModal()">&times;</button>
    </div>
    <div class="modal-body">
      <app-custom-request-quote
        [customStyle]="{
          right: '-40px',
          width: 'auto',
          maxWidth: '630px',
          padding: '10px 34px !important',
          top: '-113px',
        }"
        [fromPage]="'Floating button -Request Quote '"
      ></app-custom-request-quote>
    </div>
  </div>
</div>
